import { useState, type FormEvent } from "react";

const symbolPattern = /^[A-Z][A-Z0-9.-]{0,19}$/u;

export function TickerSymbolPicker({
  symbol,
  suggestions,
  onOpen,
}: {
  readonly symbol: string;
  readonly suggestions: readonly string[];
  readonly onOpen: (symbol: string) => void;
}) {
  const [draft, setDraft] = useState(symbol);
  const [error, setError] = useState("");
  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const normalized = draft.trim().toUpperCase();
    if (!symbolPattern.test(normalized)) {
      setError("Enter a stock symbol using letters, numbers, periods, or hyphens.");
      return;
    }
    setError("");
    onOpen(normalized);
  };
  return (
    <form className="ticker-symbol-picker" onSubmit={submit}>
      <div className="field-stack">
        <label htmlFor="symbol-input">Symbol</label>
        <input
          autoComplete="off"
          id="symbol-input"
          list="ticker-symbol-suggestions"
          maxLength={20}
          onChange={(event) => setDraft(event.currentTarget.value)}
          required
          value={draft}
        />
        <datalist id="ticker-symbol-suggestions">
          {suggestions.map((value) => (
            <option key={value} value={value} />
          ))}
        </datalist>
      </div>
      <button className="button button--quiet" type="submit">
        Go
      </button>
      {error === "" ? null : <small role="alert">{error}</small>}
    </form>
  );
}
